export enum Routes {
    // Portal routes
    PublicHome = '/',

    PublicHomePricingPlans = '/#pricingplans',
    PublicHomeContact = '/#contact',
    PublicPrivacyPolicy = '/polityka-prywatnosci.pdf',
    PublicRegulation = '/regulamin.pdf',
}